import { Project } from '../types'

export type Plant = {
  id: number
  code: string
  name: string
}

export type Order = {
  id: number
  description: string
}

export type Summary = {
  plannedAmount: number
  deliveredAmount: number
  remainingAmount: number
  progressPercentage: number
  projectCount: number
  orderCount: number
  deviationCount: number
}

export type PlantData = Plant & {
  summary: Summary
}

export type OrdersStatus = {
  orderCount: number
  completed: number
  completedPercentage: number
  partlyDelivered: number
  partlyDeliveredPercentage: number
  notStarted: number
  notStartedPercentage: number
  onCall: number
  receiptsCount: number
}

export const OrderStatus = {
  running: 0,
  upcoming: 1,
  onCall: 2,
  laggingBehind: 3
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];

export type OrderDeliveries = {
  summary: OrderDeliveriesSummary
  items: OrderDeliveryItem[]
}

export type OrderDeliveriesSummary = {
  running: number
  upcoming: number
  onCall: number
  overdue: number
}

export type OrderDeliveryItem = {
  order: Order
  orderId: number
  time: string
  plant: Plant
  project: Project
  plannedAmount: number
  deliveredAmount: number
  remainingAmount: number
  status: OrderStatus
}

export type PlantCapacities = {
  onCall: PlantCapacitiesOnCall
  plants: PlantCapacity[]
}

export type PlantCapacitiesOnCall = {
  orderCount: number
  amount: number
}

export type PlantCapacity = {
  plant: Plant
  productionCapacity: number
  periods: PlantCapacityPeriod[]
}

export type PlantCapacityPeriod = {
  timeFrom: string
  timeTo: string
  plannedAmount: number
  loadPercentage: number
}

export type DashboardDeviation = {
  subjectType: number
  category: number
  type: number
  severity: number
  subjectID: number
  description: string
  count?: number
}

export type ProjectDeviations = {
  subjectType: number
  type: number
  count: number
}

export type ProjectsOrdersDashboardData = {
  plants: Plant[]
  plantsData: PlantData[]
  deviations: ProjectDeviations[]
  ordersStatusByPlant: Record<number, OrdersStatus>
  orderDeliveries: OrderDeliveries
  plantCapacities: PlantCapacities
}
